const MASK_GROUP = '••••';

/**
 * Cosmetic masking of account numbers / IBANs for on-screen display: only the last 4 characters
 * stay visible, behind a fixed pattern (`•••• •••• •••• 1201`) so the length is not revealed.
 * Values of 4 characters or fewer are fully masked. The full value is still in the API response.
 */
export function maskAccount(value: string | null | undefined): string {
    const v = (value ?? '').replace(/\s+/g, '');
    if (!v) return '';
    if (v.length <= 4) return [MASK_GROUP, MASK_GROUP, MASK_GROUP, MASK_GROUP].join(' ');
    return `${MASK_GROUP} ${MASK_GROUP} ${MASK_GROUP} ${v.slice(-4)}`;
}
